import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div>
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container" style={{ maxWidth: '900px' }}>
          <h1 className="hero-medium" style={{ marginBottom: '48px' }}>Privacy Policy – Delhi Guided Tours</h1>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
            <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
              Delhi Guided Tours respects your privacy.
            </p>

            <div>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>1. Information Collected</h2>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                We may collect names, phone numbers, email addresses, and booking or enquiry details.
              </p>
            </div>

            <div>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>2. Usage of Information</h2>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Information is used only to respond to enquiries, manage bookings, and communicate tour-related updates.
              </p>
            </div>

            <div>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>3. Data Sharing</h2>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Information is shared only with payment gateways or service partners when required.
              </p>
            </div>

            <div>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>4. Data Protection</h2>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Reasonable security measures are used to protect personal data.
              </p>
            </div>

            <div>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>5. Communication Consent</h2>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                By contacting or booking with us, you consent to communication via WhatsApp, email, or phone.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;